// extracted by mini-css-extract-plugin
export default {"formContainer":"VerifyEmail_formContainer__BmPwi","textWrapper":"VerifyEmail_textWrapper__hPzpj","loginControl":"VerifyEmail_loginControl__7GS5k"};